// extracted by mini-css-extract-plugin
module.exports = {"md":"feedback-widget_md_38Wgx","ios":"feedback-widget_ios_2GQqY","widget":"feedback-widget_widget_1Ipdm","rating":"feedback-widget_rating_qQ01v"};